import { jsx as _jsx } from "react/jsx-runtime";
import MenuAllv from "./menuAllv";
import { useGetAllMenuQuery } from "@/store/api";
import widgetsDictionary from "@/components/widgets/widgetsDictionary";
import { useMemo } from "react";
import { slotDirection } from "@/utils/funcs";
import { SlotDirection } from "@/utils/types/layout";
import queryString from "query-string";
export default function Menu(props) {
    var _a;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var menuResponse = useGetAllMenuQuery(null).data;
    var main = ((_a = menuResponse === null || menuResponse === void 0 ? void 0 : menuResponse.data) === null || _a === void 0 ? void 0 : _a.main) || [];
    var mainMenu = useMemo(function () {
        var mainMenu = {};
        var list = main || {};
        var links = list.links;
        for (var key in list.tabs) {
            var modules = list.tabs[key].modules;
            var moduleLinks = [];
            for (var moduleKey in modules) {
                moduleLinks[moduleKey] = {
                    modules: links[moduleKey],
                };
            }
            mainMenu[key] = { modules: moduleLinks };
        }
        return mainMenu;
    }, [menuResponse]);
    var createMenu = useMemo(function () {
        var _a, _b, _c, _d;
        var list = main || {};
        var links = (list === null || list === void 0 ? void 0 : list.links) || {};
        var moduleLinks = {};
        var modules = (_b = (_a = list === null || list === void 0 ? void 0 : list.tabs) === null || _a === void 0 ? void 0 : _a.LBL_TABGROUP_ALL) === null || _b === void 0 ? void 0 : _b.modules;
        var _loop_1 = function (moduleKey) {
            var clientLinks = {};
            var linksUrls = (_c = links[moduleKey]) === null || _c === void 0 ? void 0 : _c.links;
            var image = (_d = links[moduleKey]) === null || _d === void 0 ? void 0 : _d.image;
            linksUrls.forEach(function (element) {
                var window = {};
                var location = window.location || {};
                var protocol = location.protocol || "http";
                var host = location.host || "localhost";
                var url = new URL(element.url, process.env.ETCRM_URL || "".concat(protocol, "://").concat(host));
                var query = url.search.split("?");
                var qs = query.length > 1 ? query[1] : query[0];
                var queryParts = queryString.parse(qs);
                var newLinkParts = [];
                var module = queryParts.module || "";
                var action = queryParts.action && queryParts.action !== "index"
                    ? queryParts.action
                    : "";
                delete queryParts.module;
                delete queryParts.action;
                for (var p in queryParts) {
                    newLinkParts.push("".concat(p, "=").concat(queryParts[p]));
                }
                var q = newLinkParts.length > 0 ? "?".concat(newLinkParts.join("&")) : "";
                clientLinks[element.id] = "".concat(module, "/").concat(action).concat(q);
            });
            moduleLinks[moduleKey] = {
                links: links[moduleKey],
                clientLinks: clientLinks,
                image: image,
            };
        };
        for (var moduleKey in modules) {
            _loop_1(moduleKey);
        }
        return moduleLinks;
    }, [main]);
    var filteredMenu = useMemo(function () {
        var links = [];
        var menu = createMenu;
        for (var m in menu) {
            if (menu[m].links.links.length) {
                links[m] = menu[m];
            }
        }
        return links;
    }, [createMenu]);
    var direction = (props === null || props === void 0 ? void 0 : props.widget.slot)
        ? slotDirection(props === null || props === void 0 ? void 0 : props.widget.slot)
        : SlotDirection.VERTICAL;
    return _jsx(MenuAllv, {});
}
widgetsDictionary.register("etcrm/widgets/default/simple/menu", {
    name: "Simple menu",
    display: Menu,
});
